import { FunctionComponent, PropsWithChildren } from 'react';

import { useFeatureGate } from '@atlassian/feature-gates-react';
import { OAuthConsentFeatureGate } from '../../../FeatureGates/FeatureGates';
import { useApplicationCollaboratorAccessCheck } from './getPluginCollaborators';
import { useInfo } from '../../../Flow/ConsentContextProvider';
import { noAccessError } from '../../../../definitions/errors';

/**
 * Restricts the Trello consent screen to app authors and collaborators
 * when the contributor gate feature flag is enabled.
 */
const AccessGateInner: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const hasAccess = useApplicationCollaboratorAccessCheck();

  if (!hasAccess) {
    throw noAccessError;
  }

  return <>{children}</>;
};

const AccessGate: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const isContributorGateEnabled = useFeatureGate(
    OAuthConsentFeatureGate.TRELLO_CONTRIBUTOR_GATE,
  );
  const info = useInfo();
  const appId = info.client?.appId;

  // Skip the gate if the feature flag is off or if there's no appId
  // (the collaborator query requires a valid appId).
  if (!isContributorGateEnabled || !appId) {
    return <>{children}</>;
  }

  return <AccessGateInner>{children}</AccessGateInner>;
};

export default AccessGate;
